/** @format */

import React from 'react'

import { Form, Button, Card, Select, Input } from 'antd'

import { servicesResendPos } from './services'

import './style.css'

export default function ResendPosV2() { //TODO REFACTOR
	return (
		<Card title='Reenviar Pos'>
			<div className='ph-resend-pos-container'>
				<div className='ph-resend-pos-main-container'>
					<h1 className='ph-resend-pos-title'>
						Ingrese ID de la orden y la farmacia a la que pertenece
					</h1>
					<Form
						name='basic'
						initialValues={{ remember: true }}
						onFinish={(item) => servicesResendPos(item)}
						className={'ph-resend-pos-form-container'}>
						<Form.Item label='Codigo de la orden' name='trx_id' rules={[{ required: true }]}>
							<Input />
						</Form.Item>
						<Form.Item label='Farmacia' name='pharmacy' rules={[{ required: true }]}>
							<Select>
								<Select.Option value='ahumada'>Ahumada</Select.Option>
								<Select.Option value='jvf'>Jvf</Select.Option>
								<Select.Option value='anich'>Anich</Select.Option>
								<Select.Option value='panul'>Panul</Select.Option>
								<Select.Option value='farmafull'>Farmafull</Select.Option>
							</Select>
						</Form.Item>
						<Form.Item>
							<div className='ph-resend-pos-button-container'>
								<Button htmlType='submit' className='ph-resend-pos-button'>
									Reenviar
								</Button>
							</div>
						</Form.Item>
					</Form>
				</div>
			</div>
		</Card>
	)
}
